<template>
  <h1>{{ $t('barcode.header') }}</h1>
  <div class="row">
    <p>{{ $t('barcode.infotext') }}</p>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col d-flex justify-content-center" v-if="store.user && validCardnumber(store.user.borrower.cardnumber)">
      <div class="card text-center border-0">

        <div class="ub-card-image">
          <img :src="'/img/bibliotekskort-'+$i18n.locale+'.png'" :alt="$t('navbar.barcode')" />
          <div class="ub-card-barcode">
            <div class="barcode-content">
              <div class="barcode-stripes">
                <span :class="'barcode-module-'+char" v-for="(char, index) in generateCode128C(store.user.borrower.cardnumber)" :key="index"></span>
              </div>
              <div class="barcode-footer">
                <span>{{printNumbers(store.user.borrower.cardnumber)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/pinia/store'

function generateCode128C(digits) {
    const code128Patterns = [
        "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
        "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
        "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
        "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
        "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
        "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
        "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
        "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
        "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
        "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
        "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
    ];

    const START_C = 105;
    const STOP = 106;

    let sum = START_C;
    let sequenceValues = [START_C];

    for (let i = 0; i < digits.length; i += 2) {
        let value = parseInt(digits.substring(i, i + 2), 10);
        let weight = (i / 2) + 1;
        sum += value * weight;
        sequenceValues.push(value);
    }

    let checksum = sum % 103;
    sequenceValues.push(checksum);
    sequenceValues.push(STOP);

    const spaceChars = { '1': 'A', '2': 'B', '3': 'C', '4': 'D' };
    let finalString = "";

    for (let val of sequenceValues) {
        let pattern = code128Patterns[val];
        for (let i = 0; i < pattern.length; i++) {
            if (i % 2 === 0) {
                finalString += pattern[i];
            } else {
                finalString += spaceChars[pattern[i]];
            }
        }
    }

    return finalString;
}
// Take a value as a string "4000000000" for example and return "4 000 000 000" with spaces every three digits (from the right)
function printNumbers(valueAsString) {
    let result = "";
    for (let i = 0; i < valueAsString.length; i++) {
        if (i > 0 && (valueAsString.length - i) % 3 === 0) {
            result += " ";
        }
        result += valueAsString[i];
    }
    return result;
}

export default {
  setup() {
    const store = useStore()
    const validCardnumber = (cardnumber) => {
      return /^\d{10}$/.test(cardnumber);
    }
    return {
      store,
      generateCode128C,
      printNumbers,
      validCardnumber
    }
  },
}
</script>

<style>
:root {
  --barcode-height: 15vw;
  --barcode-max-height: 4.5rem;
  --barcode-footer-height: 3vw;
  --barcode-footer-max-height: 15rem;
}
.ub-card-image {
  position: relative;
  width: 100%;
  max-width: 30rem;
  img {
    width: 100%;
    height: auto;
  }
}

.ub-card-barcode {
  display: flex;
  flex-direction: column;
  /* Position the barcode at the bottom center of the card image */
  position: absolute;
  width: 100%;
  max-width: 30rem;
  bottom: calc(min(var(--barcode-height), var(--barcode-max-height)) - min(10vw,2.75em));

  .barcode-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    container-type: inline-size;
    .barcode-footer {
      font-size: 5cqi;
    }
  }
  .barcode-stripes {
    display: flex;
    width: 50%;
    align-self: center;

    span {
      height: var(--barcode-height);
      max-height: var(--barcode-max-height);
    }

    span.barcode-module-1 {
      background-color: black;
      flex-basis: 1em;
      display: inline-block;
    }
    span.barcode-module-2 {
      background-color: black;
      flex-basis: 2em;
      display: inline-block;
    }
    span.barcode-module-3 {
      background-color: black;
      flex-basis: 3em;
      display: inline-block;
    }
    span.barcode-module-4 {
      background-color: black;
      flex-basis: 4em;
      display: inline-block;
    }
    span.barcode-module-A {
      background-color: transparent;
      flex-basis: 1em;
      display: inline-block;
    }
    span.barcode-module-B {
      background-color: transparent;
      flex-basis: 2em;
      display: inline-block;
    }
    span.barcode-module-C {
      background-color: transparent;
      flex-basis: 3em;
      display: inline-block;
    }
    span.barcode-module-D {
      background-color: transparent;
      flex-basis: 4em;
      display: inline-block;
    }
  }
}
</style>